import { Button, Form, Input, Select, Spin } from 'antd'
import Table from 'components/atoms/table'
import styled from 'styled-components'

export const StyledButtonImg = styled.img`
  cursor: pointer;
`
export const StyledButtonIcon = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
`
export const StyledFormModal = styled(Form)`
  padding: 16px 24px 0px 24px;
`
export const StyledButtonRed = styled(Button)`
  background: var(--color-red-106);
  border-color: var(--color-red-106);
  &:hover {
    background: var(--color-red-106);
    opacity: 0.85;
    border-color: var(--color-red-106);
  }
`
export const StyledSearchInput = styled(Input)`
  ::hover {
    border-color: var(--color-primary-109);
  }
  width: 100%;
  height: 34px;
  .ic-search {
    cursor: pointer;
    &:hover {
      opacity: 0.85;
    }
  }
`
export const StyleTabBtn = styled.li`
  padding: 9px 16px;
  background-color: #fff;
  color: #555555;
  text-align: center;
  cursor: pointer;
  font-weight: 500;
  border-radius: 8px;
  border: 1px solid transparent;

  &.active {
    background-color: var(--color-primary-108);
    border: 1px solid var(--color-primary-108);
    color: #fff;
  }

  &:hover {
    border: 1px solid var(--color-primary-108);
  }

  & + li {
    margin-left: 4px;
  }
`

export const StyleCardBody = styled.div`
  padding: 16px;
  background: #fff;
  box-shadow: 0px 1px 30px rgba(85, 85, 85, 0.1);
  border-radius: 8px;
  position: relative;
`
export const StyledHeader = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 1.4rem;
  .img {
    margin-right: 4px;
  }
`

export const StyleCardSession = styled.div`
  margin-bottom: 15px;
`

export const StyleCardTitle = styled.div`
  font-weight: 800;
  text-transform: uppercase;
  color: #000000;
  margin-bottom: 10px;
`
export const StyleCardTitle2 = styled.div`
  font-weight: 800;
  text-transform: uppercase;
  color: #000000;
  display: flex;
  margin-bottom: 10px;
`
export const StyledLabel = styled.label`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
  display: block;
`

export const StyledLabelSpan = styled.span`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
`

export const StyledLabelInline = styled.label`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
`

export const StyledTable = styled(Table)<{
  $maxHeight?: string
  $height?: string
}>`
  .pointer {
    cursor: pointer;
  }
  min-height: 0;
  flex: 1;
  ${({ $maxHeight }) =>
    $maxHeight
      ? `.ant-table-body {
    max-height: ${$maxHeight};
  }`
      : ''}
  ${({ $height }) =>
    $height
      ? `.ant-table-body {
      height: ${$height};
    }`
      : ''}
`
export const StyledTable2 = styled(Table)<{
  $maxHeight?: string
  $height?: string
}>`
  .ant-table-container {
    > .ant-table-header {
      .ant-table-thead {
        th {
          text-overflow: ellipsis;
          text-transform: none !important;
        }
      }
    }
    .pointer {
      cursor: pointer;
    }
    min-height: 0;
    flex: 1;
    ${({ $maxHeight }) =>
      $maxHeight
        ? `.ant-table-body {
    max-height: ${$maxHeight};
  }`
        : ''}
    ${({ $height }) =>
      $height
        ? `.ant-table-body {
      height: ${$height};
    }`
        : ''}
  }
`
export const StyleContentModal = styled.div`
  height: calc(90vh - 120px);
  overflow: auto;
  overflow-x: hidden;
  padding: 24px;
`
export const StyleSpinDisabled = styled(Spin)`
  .ant-spin-blur {
    opacity: 0.85 !important;
  }
`

export const StyleContainerCard = styled.div`
  background-color: #ffffff;
  box-shadow: 0px 1px 30px rgba(85, 85, 85, 0.1);
  border-radius: 8px;
  margin-bottom: 10px;
  padding: 10px 15px;
`

export const StyledImg = styled.img<{ $size?: number; $isWhite?: boolean }>`
  width: ${({ $size = 16 }) => $size}px !important;
  height: ${({ $size = 16 }) => $size}px !important;
  ${({ $isWhite }) =>
    $isWhite
      ? ` filter: invert(95%);
          -webkit-filter: invert(95%);`
      : ''}
`

export const StyleLabel = styled.div<{ $required?: boolean }>`
  font-size: 1.4rem;
  color: var(--color-gray-111);
  font-weight: 600;
  ${({ $required }) => {
    if ($required) {
      return `&::after {
        content: "*";
        display: inline-block;
        color: var(--color-red-107);
        margin-left: 2px;
      }`
    }
  }}
`
export const StyleLabelSpan = styled.span<{ $required?: boolean }>`
  font-size: 1.4rem;
  color: var(--color-gray-111);
  font-weight: 600;
  ${({ $required }) => {
    if ($required) {
      return `&::after {
        content: "*";
        display: inline-block;
        color: var(--color-red-107);
        margin-left: 2px;
      }`
    }
  }}
`
export const StyleError = styled.div<{ $invalid?: boolean }>`
  font-size: 1.2rem;
  color: var(--color-red-106);
  font-weight: 400;
  display: none;
  ${({ $invalid }) => {
    if ($invalid) {
      return `display: block;`
    }
  }}
`
export const StyledTableNote = styled.div`
  width: 100%;
  white-space: pre-wrap;
  display: block;
  display: -webkit-box;
  max-height: 4.2em;
  line-height: 1.3em;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const StyledStatus = styled.span<{
  $status?: 'failed' | 'pending' | 'success'
}>`
  ${({ $status }) => {
    switch ($status) {
      case 'success':
        return `color: var(--color-primary-108);`
      case 'pending':
        return `color: var(--color-yellow-106);`
      case 'failed':
        return `color: var(--color-orange-107);`
    }
  }}
`

// export const StyledAutoComplete = styled(Select)`
//   .ant-select .ant-select-selector,
//   .ant-select-selector,
//   .ant-select-focused {
//     border: 1px solid var(--color-gray-103) !important;
//     border-radius: 4px !important;
//     padding: 0px !important;
//   }
// `

export const StyledAutoComplete = styled(Select)`
  width: 100% !important;
  input {
    padding: 8px !important;
  }
`
export const DivIndex = styled.div`
  color: gray;
`
